export default function placeholder(columns, code, text) {
  const placeholderData = columns[code].reduce(
    (acc, column, idx) => ({
      ...acc,
      [column.dataKey]: !idx ? text : null,
    }),
    {}
  );
  placeholderData.id = 0;

  return [placeholderData];
}
